// Order matters for Biz Admin Premium menu editor
export const MenuTabEnum = [
  'featured',
  'specials',
  'brand_specials',
  'flower',
  'edible',
  'pre-roll',
  'extract',
  'tincture',
  'topical',
  'vape',
  'merch',
  'gear',
  'grow',
  'all-products',
] as const;

export type MenuTab = (typeof MenuTabEnum)[number];
